import { render, staticRenderFns } from "./civil-engineering-3.vue?vue&type=template&id=a49185ac&"
import script from "./civil-engineering-3.vue?vue&type=script&lang=js&"
export * from "./civil-engineering-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports